import { IconX } from "@tabler/icons-react";
import { classNames } from "@ct-react/core";

import "./pop-up.scss";

type Props = {
  children: React.ReactNode,
  className?: string,
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>
}

const PopUp = ({
  children,
  className,
  setIsOpen
}:Props) => {

  const classes = `close ${className}`;

  return(
    <div className="pop-up">
      <button type="button" className={classes} aria-label="Fermer la pop-up" onClick={() => setIsOpen(false)}>
        <IconX/>
      </button>
      {children}
    </div>
  );
};

export default PopUp;
